export { DMS_MODULE } from '../constants';
export const NAME = 'UpozorneniUdalost';
export const CRUMB_LABEL_KEY = 'edtDmsJobs';
